import { render, staticRenderFns } from "./PurchasePanel.vue?vue&type=template&id=30f0c08f&"
import script from "./PurchasePanel.vue?vue&type=script&lang=js&"
export * from "./PurchasePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports